<template>
  <div class="headFixed" @click="hideSomething">
    <div class="detail_head fixed_head">
      <div>
        <div class="content">
          <div class="go_back">
            <span @click="goBack" class="goBackBtn"></span>
            {{ eqInfo ? eqInfo.name : '' }}
            <img v-show="eqInfo" @click.stop="changeMenu" class="right menuImg" width="25"
                 src="../../../assets/images/menu.png" alt=""/>
          </div>
        </div>
      </div>
      <div class="menu" v-show="showMenu">
        <ul>
          <router-link :to="'/equipment/info/'+this.getId()">
            <router-link :to="'/equipment/info/' + this.getId()">
              <li>设备信息</li>
            </router-link>

          </router-link>
          <router-link :to="'/equipment/status/' + this.getId()" v-show="eqInfo && eqInfo.deviceType == 1">
            <li>设备状态</li>
          </router-link>
          <!--          <li>设备密码</li>-->
          <li @click="eqUnbind">解除绑定</li>
        </ul>
      </div>
    </div>
    <div class="noInfo" v-show="showEmpty">暂无信息</div>
    <div>
      <div class="eqInfoDetail" v-if="eqInfo && !showEmpty">
        <div>
          <div class="detail_top">
            <span v-show="eqInfo.airCondition.setMode === '2'" class="hotBg"></span>
            <span v-show="eqInfo.airCondition.setMode === '1'" class="coolBg"></span>
            <div></div>

            <div class="degrees">
              <canvas id="clock" width="220px" height="220px"></canvas>
              <canvas id="pointer" width="220px" height="220px"></canvas>
              <p :class="this.drawDegree == null ? 'noDegree' : ''">
                {{ this.drawDegree == null ? '暂无设置' : this.drawDegree + '℃' }}
                <span class="type" v-if="eqInfo.airCondition.setMode === '1'"><span>制冷</span></span>
                <span class="type" v-else-if="eqInfo.airCondition.setMode === '2'"><span>制热</span></span>
                <span class="type" v-else-if="eqInfo.airCondition.setMode === '0'"><span>通风</span></span>
                <span class="type" v-else><span></span>{{ eqInfo.airCondition.setMode }}</span>
              </p>
            </div>
          </div>
          <ul class="setDegree clear">
            <li class="left">
							<span class="text-center eqDegree" v-show="eqInfo.airCondition.setMode === '1'">
								<span>
									{{ eqInfo.airCondition.coolTemp ? eqInfo.airCondition.coolTemp : 0 }}
									<span class="unit">℃</span>
								</span>
								制冷设定
							</span>
              <span class="text-center eqDegree"
                    v-show="eqInfo.airCondition.setMode === '2'">
								<span>
									{{ eqInfo.airCondition.heatTemp ? eqInfo.airCondition.heatTemp : 0 }}
									<span class="unit">℃</span>
								</span>
								制热设定
							</span>
            </li>
            <li class="right"><p class="setDegreeBtn" @click="showDegreeModel"></p>
            </li>
          </ul>
        </div>

        <div class="eqType">
          <ul class="clear">
            <!--          开关切换-->
            <li class="li-open" @click="eqStart"
                v-if="eqInfo.airCondition.unitStatus === '0' || eqInfo.airCondition.unitStatus === '3' ">
              <span></span>
              开机
            </li>
            <li class="li-open li-open2" @click="shutDown" v-else>
              <span></span>
              关机
            </li>

            <!--          切换模式-->
            <li class="li-mode" @click="changeEqMode">
              <span></span>
              模式
            </li>

            <!--          告警-->
            <li class="li-alert" :class="eqInfo.airCondition.faultInd == 1 ? 'alert-dannger' : ''" v-if="type == 1">
              <router-link :to="'/fault/' + this.getId()">
                <span></span>
                报警
              </router-link>
            </li>

            <li class="li3">
              <router-link :to="'/equipment/timer/air/' + this.getId()">
                <span></span>
                定时
              </router-link>
            </li>
          </ul>
        </div>

        <div class="list list_normal list_no_arrow list_info" style="margin-top:10px">
          <div class="item">
            <div class="clear">
              <p>
                场景
                <span class=" right yh">
									<span class="yh2">{{ eqInfo.sceneName }}</span>
									{{ eqInfo.roomName }}
									<i class="icon-edit" @click="chooseScene"></i>
								</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="tip detail_tip" v-show="showTip">
        <div class="content">
          <div class="tip_body">
            <div class="modal-warning">
              <span></span>
              <p>温馨提示：请关机后再切换模式</p>
            </div>
          </div>
          <div class="tip_foot tip_foot_detail"><span @click="hideModal">取消</span></div>
        </div>
      </div>
    </div>

    <!--        关机提示-->
    <div class="tip detail_tip" v-show="closeTip">
      <div class="content">
        <div class="tip_body closeTip_body">
          <div class="modal-warning">
            <span :class="this.closeIcon"></span>
            <p>{{ this.closeText }}</p>
          </div>
        </div>
      </div>
    </div>

    <mt-popup v-model="showModel" modal="false" class="pubPopup" popup-transition="popup-fade" position="bottom">
      <p class="tipText">模式切换</p>
      <mt-radio title="" v-model="eqModeVal"
                :options="this.modelList"></mt-radio>
      <!-- <div class="btns"> -->
      <p class="p-ui">
        <mt-button size="large" class="btn-orange" @click="changeMode">确定</mt-button>
      </p>
      <p class="p-ui2">
        <mt-button size="large" @click="cancelModel">取消</mt-button>
      </p>
    </mt-popup>

    <!--    温度切换-->
    <mt-popup v-model="showDegrees" class="pubPopup" defaultIndex="[3]" position="bottom">
      <p class="tipText tip-text-border">温度选择</p>
      <mt-picker :slots="this.eqInfo.airCondition.setMode === '1' ? coolMain : hotMain"
                 @change="onValuesChange"
                 ref="mainDegrees"></mt-picker>
      <p class="p-ui">
        <mt-button size="large" class="btn-orange" @click="changeDegree">确定</mt-button>
      </p>
      <p class="p-ui2">
        <mt-button size="large" @click="cancelDegreeModel">取消</mt-button>
      </p>
    </mt-popup>

    <!--解绑弹窗-->
    <div class="tip detail_tip" v-show="showUnBind">
      <div class="content">
        <div class="tip_body">
          <div class="modal-warning">
            <span></span>
            <p>温馨提示：确定解除绑定吗</p>
          </div>
        </div>
        <div class="tip_foot">
          <span @click="hideModalCom('showUnBind')">取消</span>
          <span @click="sureBind">确定</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Range, Toast, Popup, Radio, Indicator} from 'mint-ui';

export default {
  name: 'detail',
  data() {
    return {
      rangeValue: 50,
      showRange: false,
      list: [],
      showMenu: false,
      showTip: false,
      eqId: this.$route.params.id,
      totalDegree: 45,
      eqInfo: {
        airCondition: {}
      },
      eqModeVal: null,
      type: 1,
      equipmentFanMode: 1, //(1:on 0:自动 2:循环 3: 低速 4: 中速 5: 高速)
      degrees: 0,
      popupVisible: false,
      eqFlag: 1,
      stopRequest: false,
      showModel: false,
      alreadyLoad: false,
      value: '2',
      modelList: [
        {
          value: '2',
          label: '制热'
        },
        {
          value: '1',
          label: '制冷'
        }
      ],
      showDegrees: false,
      valueDegrees: null,
      hotMain: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center',
          value: 15,
          defaultIndex: 10
        }
      ],
      coolMain: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center',
          value: 15,
          defaultIndex: 5
        }
      ],
      slotsFan: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center'
        }
      ],
      roomTep: null,
      firstRequest: true,
      isRequest: true,
      showEmpty: false,
      showUnBind: false,
      closeTip: false,
      closeText: '关机中...',
      closeIcon: 'icon-loading-off',
      socket: '',
      drawDegree: null
    };
  },
  beforeMount() {
    let num = this.totalDegree;
    let list = [];
    for (let i = 0; i < num; i++) {
      list.push(i);
    }
    this.list = list;
    setTimeout(() => {
      this.timer();
    }, 200);

    // 温度
    // 主机制冷7-25
    let mainCool = [];
    for (let i = 7; i <= 25; i++) {
      mainCool.push(i);
    }
    this.coolMain[0].values = mainCool;

    // 主机制热15-45
    let mainHot = [];
    for (let i = 15; i <= 45; i++) {
      mainHot.push(String(i));
    }
    this.hotMain[0].values = mainHot;

    // 风盘温度15-35
    let fanDegree = [];
    for (let i = 15; i <= 35; i++) {
      fanDegree.push(String(i));
    }
    this.slotsFan[0].values = fanDegree;
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {

      if (this.getId()) {
        this.eqDetail(this.getId());
      }
    },
    getId() {
      return this.$route.params.id;
    },
    watchDegree() {
      if (this.eqInfo.airCondition.setMode == 1) {
        this.adjustCoolTemperature(this.degrees);
      } else if (this.eqInfo.airCondition.setMode == 2) {
        this.adjustHeatTemperature(this.degrees);
      } else if (this.eqInfo.airCondition.setMode == 7) {
        this.adjustHeatTemperature(this.degrees);
      } else if (this.eqInfo.airCondition.setMode == 8) {
        this.adjustHeatTemperature(this.degrees);
      }
    },
    changeDegree() {
      let degree = this.valueDegrees[0];
      if (this.eqInfo.airCondition.setMode === '1') {
        this.adjustCoolTemperature(degree);
      } else if (this.eqInfo.airCondition.setMode === '2') {
        this.adjustHeatTemperature(degree);
      }
    },
    initDraw() {
      if (this.eqInfo.airCondition.userRetTemp){
        this.drawDegree = this.eqInfo.airCondition.userRetTemp
      }
      let degrees = this.drawDegree;
      if (degrees || degrees == 0) {
        this.drawPointer(degrees);
        this.drawGreenCricle(degrees);
        this.drawCircle(degrees);
      }
    },
    eqDetail(id) {
      Indicator.open({
        spinnerType: 'fading-circle'
      });
      this.Api.eqDetail(
          id,
          msg => {
            //初始化websocket
            if (typeof WebSocket === 'undefined') {
              alert('您的浏览器不支持socket');
            } else {
              // 实例化socket
              this.socket = this.$store.state.websocket
              if (!this.socket) {
                this.socket = new WebSocket(this.$websocketUrl + id);
              }
              // 监听socket连接
              this.socket.onopen = this.socketopen;
              // 监听socket错误信息
              this.socket.onerror = this.socketerror;
              // 监听socket消息
              this.socket.onmessage = this.getMessage;
              // 关闭socket消息
              this.socket.onclose = this.socketclose;
              this.$store.commit('setWebSocket', this.socket);
            }
            if (msg.data) {
              this.eqInfo = msg.data;
              if (this.eqInfo.airCondition) {
                this.eqModeVal = this.eqInfo.airCondition.setMode;
                this.drawDegree = this.eqInfo.airCondition.userRetTemp;

              } else {
                this.eqInfo.airCondition = {
                  'setMode': 1,
                  'userRetTemp':'1'
                }

              }
              this.initDraw();
              this.drawCircle();
            } else {
              this.showEmpty = true;
            }
          }
      );
    },
    eqDel() {
      let params = {};
      params.id = this.eqId;
      this.Api.eqDel(params, msg => {
        if (msg.code == 200) {
          let str = 'pageNo=1';
          this.eqList(str);
        } else {
          Toast(msg.message);
        }
      });
    },
    eqStart() {
      let data = {
        'iotDeviceId': this.getId()
      }
      this.Api.startUp(data, (msg) => {
        if (msg.code === 200) {
          this.closeInterval(1);
        } else {
          Toast(msg.message);
        }
      });
    },

    closeInterval(flag) {
      this.closeTip = true;
      let type = '关机';
      this.closeIcon = 'icon-loading-off';
      if (flag == 1) {
        type = '开机';
        this.closeIcon = 'icon-loading-on';
      }
      let str = 'id=' + this.getId();
      let time = 10;
      this.closeText = type + '中 ' + time + '秒';
      this.closeTimer = setInterval(() => {
        time--;
        this.closeText = type + '中 ' + time + '秒';
        if (time <= 0) {
          this.closeTip = false;
          clearInterval(this.closeTimer);
          time = 10;
          Toast(type + '成功');
          this.init();
        }
      }, 1000);
    },

    shutDown() {
      // let str = 'id=' + this.getId();
      let data = {
        'iotDeviceId': this.getId()
      }
      this.Api.shutDown(data, (msg) => {
        if (msg.code === 200) {
          // Toast('关机成功');
          this.closeInterval();
          // this.closeTip = false;
          // clearInterval(this.closeTimer);
          // this.init();
        } else {
          Toast(msg.message);
        }
      });
    },
    // 切换制热模式
    adjustHeatMode() {
      let data = {
        'iotDeviceId': this.getId()
      }
      this.Api.adjustHeatMode(data, (msg) => {
        if (msg.code === 200) {
          Toast('设置制热模式成功');
          this.hideModal();
          this.init();
        } else {
          Toast(msg.message);
          this.hideModal();
        }
      });
    },
    // 切换制冷模式
    adjustCoolMode() {
      let data = {
        'iotDeviceId': this.getId()
      }
      this.Api.adjustCoolMode(data, (msg) => {
        if (msg.code === 200) {
          Toast('设置制冷模式成功');
          this.hideModal();
          this.init();
        } else {
          Toast(msg.message);
          this.hideModal();
        }
      });
    },
    // 调节制热温度
    adjustHeatTemperature(temperature) {
      let data = {
        "iotDeviceId": this.getId(),
        "heatTemp": temperature
      }
      this.Api.adjustHeatTemperature(data, (msg) => {
        this.cancelDegreeModel();
        if (msg.code === 200) {
          this.init();
          // Toast('设置制热温度成功')
        } else {
          Toast(msg.message);
        }
      });
    },
    // 调节制冷温度
    adjustCoolTemperature(temperature) {
      let data = {
        "iotDeviceId": this.getId(),
        "coolTemp": temperature
      }
      this.Api.adjustCoolTemperature(data, (msg) => {
        this.cancelDegreeModel();
        if (msg.code === 200) {
          this.init();
          // Toast('设置制冷温度成功')
        } else {
          Toast(msg.message);
        }
      });
    },
    cancelTimer() {
      this.popupVisible = false;
    },
    hideSomething() {
      this.showRange = false;
      this.showMenu = false;
    },
    changRange(e) {
      this.closeEq(3);
    },
    changeMenu() {
      this.showMenu = !this.showMenu;
      // alert(this.showMenu)
    },
    timer() {
      let self = this;
      // new Swiper('.swiper-container', {
      //     initialSlide: this.degrees,
      //     slidesPerView: 'auto',
      //     centeredSlides: true,
      //     slideToClickedSlide: true,
      //     on: {
      //         slideChangeTransitionEnd: function () {
      //             // self.degrees = this.activeIndex;
      //             // self.watchDegree();
      //             // self.initDraw();
      //         },
      //     },
      // })
    },
    drawCircle() {
      var canvas = document.getElementById('clock');
      var ctx = canvas.getContext('2d');
      // 绘制外环
      ctx.beginPath();
      ctx.arc(110, 110, 100, (45 / 180) * Math.PI, (135 / 180) * Math.PI, true);
      ctx.strokeStyle = 'rgba(255,255,255,0.3)';
      ctx.lineWidth = '2';
      ctx.stroke();
      ctx.closePath();
      // 绘制灰色内环
      ctx.beginPath();
      ctx.arc(110, 110, 94, (45 / 180) * Math.PI, (135 / 180) * Math.PI, true);
      ctx.strokeStyle = 'rgba(255,255,255,0.3)';
      ctx.lineWidth = '5';
      ctx.stroke();
      ctx.closePath();

      //文字-刻度-line
      ctx.strokeStyle = 'rgba(255,255,255,0.6)';
      ctx.lineWidth = 1;
      // ctx.translate(canvas.width / 4, canvas.height / 4);

      //绘制表盘的刻度线
      let clockDimensions = 95;
      let total = (60 / 4) * 3;
      let showNUm = total - 6;
      for (var i = 6; i <= showNUm; i++) {
        if (i % 5 == 0) {
          ctx.save(); //保存当前绘制环境
          ctx.beginPath();
          ctx.lineWidth = 1;
          ctx.strokeStyle = 'rgba(255,255,255,0.3)';
          //重置坐标原点（0,0）
          //绘制环境旋转方法,以（0,0）为参考点进行旋转
          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate(((Math.PI * 2) / total) * i);
          ctx.moveTo(0, clockDimensions - clockDimensions / 20);
          ctx.lineTo(0, clockDimensions - clockDimensions / 7);
          ctx.stroke();
          ctx.beginPath();
          ctx.restore(); //恢复当前保存的绘制环境
        } else {
          ctx.save();
          ctx.beginPath();
          ctx.strokeStyle = 'rgba(255,255,255,0.3)';
          ctx.lineWidth = 1;
          //重置坐标原点（0,0）
          //绘制环境旋转方法,以（0,0）为参考点进行旋转
          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate(((Math.PI * 2) / total) * i);
          ctx.moveTo(0, clockDimensions - clockDimensions / 20);
          ctx.lineTo(0, clockDimensions - clockDimensions / 10);
          ctx.stroke();
          ctx.restore();
        }
      }
    },
    drawGreenCricle(val) {
      var canvas = document.getElementById('clock');
      var ctx = canvas.getContext('2d');
      canvas.height = canvas.height;
      let total = this.totalDegree;
      let rate = val / total;
      // 绘制绿色内环
      ctx.beginPath();
      ctx.arc(110, 110, 94, 0.75 * Math.PI, (1.5 * rate + 0.75) * Math.PI, false);
      ctx.strokeStyle = '#38FFEE';
      ctx.lineWidth = '5';
      ctx.stroke();
      ctx.closePath();
    },
    drawPointer(val) {
      var canvas = document.getElementById('pointer');
      var ctx = canvas.getContext('2d');
      canvas.height = canvas.height;

      // 绘制外环
      let i = -val;
      let deg = (360 / 60) * i;
      let total = 15;
      deg = deg + 45;

      ctx.beginPath();
      ctx.translate(canvas.width / 2, canvas.height / 2);
      let r = 93;
      let x = -Math.cos((Math.PI / 180) * deg) * r;
      let y = Math.sin((Math.PI / 180) * deg) * r;
      ctx.arc(x, y, 10, 0, 2 * Math.PI, true);
      ctx.fillStyle = '#38FFEE';
      ctx.fill();
      ctx.closePath();
    },
    hideModal() {
      this.showTip = false;
      this.startInit();
      this.cancelModel();
    },
    closeEq() {
      this.showTip = true;
    },
    changeMode() {
      let flag = this.eqModeVal;
      if (flag === "1") {
        this.adjustCoolMode();
      }
      if (flag === "2") {
        this.adjustHeatMode();
      }
    },
    cancelModel() {
      this.showModel = false;
      this.startInit();
    },
    startInit() {
      // this.stopRequest = false;
      // setTimeout(() => {
      //   this.init();
      // }, 5 * 1000);
    },
    eqUnbind() {
      this.showModalCom('showUnBind');
    },
    sureBind() {
      // let str = 'id=' + this.getId();
      let data = {
        "iotDeviceId": this.getId()
      }
      this.Api.eqUnbind(data, msg => {
        this.showUnBind = false;
        if (msg.code == 200) {
          localStorage.setItem('isLo', 1);
          Toast('设备解绑成功');
          this.$router.push({
            path: '/equipment'
          });
        }
        if (msg.code == 402) {
          Toast(msg.message);
        }
      });
    },
    changeEqMode() {
      var status = this.eqInfo.airCondition.unitStatus;
      if (status !== '0' && status !== '3') {
        this.showTip = true;
      } else {
        this.showModel = true
      }
      // this.stopInit();
      // this.showModel = true;
    },
    onValuesChange(picker, values) {
      this.valueDegrees = values;
    },
    showDegreeModel() {
      if (this.eqInfo.airCondition.setMode === '1') {
        let coolTemp = parseInt(this.eqInfo.airCondition.coolTemp);
        let index = 0;
        if (coolTemp >= 25) {
          index = 18
        } else if (coolTemp <= 7) {
          index = 0;
        } else {
          index = coolTemp - 7
        }
        this.coolMain[0].defaultIndex = index
      }
      if (this.eqInfo.airCondition.setMode === '2') {
        let heatTemp = parseInt(this.eqInfo.airCondition.heatTemp);
        let index = 0
        if (heatTemp >= 45) {
          index = 30
        } else if (heatTemp <= 15) {
          index = 0;
        } else {
          index = heatTemp - 15
        }
        this.hotMain[0].defaultIndex = index
      }
      this.showDegrees = true;
    },
    cancelDegreeModel() {
      this.startInit();
      this.showDegrees = false;
    },
    goBack() {
      this.$router.push({path: '/equipment'});
    },
    hideModalCom(key) {
      this.showUnBind = false;
    },
    showModalCom(key) {
      this[key] = true;
    },
    chooseScene() {
      this.$router.push({path: this.PATH.getChooseHome() + '2?id=' + this.getId()});
    },
    socketopen: function () {
      console.log('socket连接成功');
    },
    socketerror: function () {
      console.log('连接错误');
    },
    getMessage: function (msg) {
      // this.drawDegree = msg.data;
      // this.initDraw();

      console.log(msg);

      let data = JSON.parse(msg.data);
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          // 使用 Vue.$set 确保触发响应性更新
          this.$set(this.eqInfo.airCondition, key, data[key]);
        }
      }
      this.initMode();
    },
    initMode() {
      this.eqModeVal = this.eqInfo.airCondition.setMode
      this.initDraw()
    },
    socketclose: function () {
      if (this.socket) {
        this.socket.close();
      }
      console.log('socket已经关闭');
    }
  }
};
</script>
<style scoped>
@import url('../../../assets/list.css');
@import url('../../tip/tip.css');
@import url('./detail.css');

.noDegree {
  font-size: 23px !important;
}

.yh {
  display: inline-block;
  max-width: 85%;
  text-align: right;
}

.yh2 {
  display: inline-block;
  max-width: 60%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.p-ui {
  padding: 20px 10px;
}

.p-ui2 {
  padding: 0 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/equipment/detail/detail.vue